module.exports = __webpack_public_path__ + "static/us_sip-785cfde249e0cdec93a293eb30a74a89.png";